import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homes from './pages/Homes';
import Aboutus from './pages/Aboutus';
import Project from './pages/Project';
import Partner from './pages/Partner';
import Quality from './pages/Quality';
import Contacts from './pages/Contacts';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Homes />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/projects" element={<Project />} />
            <Route path="/partners" element={<Partner />} />
            <Route path="/hse-quality" element={<Quality />} />
            <Route path="/contactus" element={<Contacts />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;